export const DYN_TABLES_STATE_MODAL_PARTIAL = 'DYN_TABLES_STATE_MODAL_PARTIAL';
